import React from 'react'
import { Link } from 'react-router-dom';
import { Button, Icon, } from "semantic-ui-react";
const UpdateTitleBar = (props) => {
    return (
        <div id="dispatch_bar" style={{ overflow: 'visible', position:'fixed', width:'100%',zIndex:'999', marginTop:'46px'}}>
            <div className="container-fluid dip_bar" style={{position:'fixed', width:'100%',zIndex:'999',}}>
                <div className="row">
                    <div className="col-sm-8">
                        <div className="d-flex justify-content-between">
                            <label className="page-heading mt-2">{props.Title}</label>

                        </div></div>
                    

                    <div className="mt-1">
                        <Button size="mini" inverted color='blue'>Allot</Button>
                        <Button size="mini" inverted color='blue'>Broadcast</Button>
                        <Button size="mini" color="red" icon inverted>
                            <Icon name='trash' />
                        </Button>
                        <form className="form-inline" action="#" style={{ float:'right' }}>
                            {!props.hideClose ?
                                <Link to={props.LinkName}>
                                    <Button size="mini" color="grey" icon inverted>
                            <Icon name='close' />
                        </Button></Link>
                                   
                                : 
                                ""}
                        </form>
                        {/* className="w3-button w3-hover-white w3-medium ml-1" */}
                         {/* <Icon name='close' className="w3-button w3-hover-white"></Icon> */}
                    </div>
                   
                      
                </div>


            </div>
        </div>
    
    )
}

export default UpdateTitleBar;
